"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var swr_hooks_1 = require("@l2p/swr-hooks");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var KYCWarning = function () {
    return (react_1.default.createElement("img", { className: styles_module_scss_1.default.kycWarning, src: "/img/icons/kyc/warning.svg", alt: "warning" }));
};
var ProfileTabs = function (_a) {
    var _b = _a.showLimits, showLimits = _b === void 0 ? true : _b;
    var t = (0, next_intl_1.useTranslations)('translation');
    var lang = (0, next_intl_1.useLocale)();
    var data = (0, swr_hooks_1.useKYCStatus)().data;
    var tabs = (0, react_1.useMemo)(function () {
        var defaultTabs = [
            {
                link: "/".concat(lang, "/account/profile/general"),
                text: t('general'),
            },
            {
                link: "/".concat(lang, "/account/profile/subscriptions"),
                text: t('subscriptions'),
            },
            {
                link: "/".concat(lang, "/account/profile/verification"),
                text: t('verification'),
                icon: (data === null || data === void 0 ? void 0 : data.status) === swr_hooks_1.KYC_STATUS.NOT_VERIFIED ? react_1.default.createElement(KYCWarning, null) : null,
            },
            {
                link: "/".concat(lang, "/account/profile/security"),
                text: t('security'),
            },
        ];
        if (showLimits)
            defaultTabs.push({
                link: "/".concat(lang, "/account/profile/gambling-limits"),
                text: t('gamblingLimits'),
            });
        return defaultTabs;
    }, [lang, t, data === null || data === void 0 ? void 0 : data.status, showLimits]);
    return react_1.default.createElement(ui_components_1.Tabs, { tabs: tabs });
};
exports.default = ProfileTabs;
